import { memo } from 'react'

const IconXCircleFill = ({
  fill,
  width,
  height,
}: {
  fill: string
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.6667 8.00004C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00004C1.33337 4.31814 4.31814 1.33337 8.00004 1.33337C11.6819 1.33337 14.6667 4.31814 14.6667 8.00004ZM10.3536 5.64649C10.5489 5.84175 10.5489 6.15833 10.3536 6.35359L8.70715 8.00004L10.3536 9.64649C10.5489 9.84175 10.5489 10.1583 10.3536 10.3536C10.1583 10.5489 9.84175 10.5489 9.64649 10.3536L8.00004 8.70715L6.35359 10.3536C6.15833 10.5489 5.84175 10.5489 5.64649 10.3536C5.45123 10.1583 5.45123 9.84175 5.64649 9.64649L7.29293 8.00004L5.64649 6.35359C5.45123 6.15833 5.45123 5.84175 5.64649 5.64649C5.84175 5.45123 6.15833 5.45123 6.35359 5.64649L8.00004 7.29293L9.64649 5.64649C9.84175 5.45123 10.1583 5.45123 10.3536 5.64649Z'
        fill={fill}
      />
    </svg>
  )
}

export default memo(IconXCircleFill)
